import { Paper } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import ProjectWorkflowContainer from './ProjectWorkflowContainer';

const Container = styled.div`
    display:flex;
    width:100%
    justify-content:center;
    padding-top:40px;
    padding-bottom:40px;

`;

class GbuFunctionDetails
 extends React.Component{


    render(){

        return (
                <Container>
                    <Paper>
                        <ProjectWorkflowContainer/>
                    </Paper>
                </Container>

        );

    }

}

export default GbuFunctionDetails;